// 76 = 14 + 48px icon column + 14; the right 14px also hold the scroll bar (Chrome thin = 11px) without moving the icons.
export const DASHBOARD_SIDEBAR_WIDTH = 76;
export const EXPANDED_SIDEBAR_WIDTH = 248;
export const SIDEBAR_CONTENT_X_PADDING = 14;
export const SIDEBAR_ACTION_ICON_SLOT_WIDTH = DASHBOARD_SIDEBAR_WIDTH - SIDEBAR_CONTENT_X_PADDING * 2;
export const SIDEBAR_BUTTON_BORDER = "1px solid";
export const SIDEBAR_BUTTON_BORDER_RADIUS = 2;
export const SIDEBAR_CONTENT_BORDER_RADIUS = 2;
export const SIDEBAR_HEADER_HEIGHT = 72;
